import { useCallback } from 'react';
import { usePagination } from 'react-instantsearch';
import styled, { css } from 'styled-components';

import { Pagination as PaginationAtom } from '@sorare/core/src/atoms/navigation/Pagination';

type Props = {
  visible: boolean;
};

const Wrapper = styled.div<{ $visible: boolean }>`
  /* give some space so that the mobile filters don't overlap as well as making the desktop usage easier */
  padding: var(--quadruple-unit) 0;
  ${({ $visible }) =>
    !$visible
      ? css`
          display: none;
        `
      : ''}
`;

export const Pagination = ({ visible }: Props) => {
  const { currentRefinement, nbPages, refine } = usePagination();

  const goToPage = useCallback(
    (page: number) => {
      refine(page);
    },
    [refine]
  );

  return (
    <Wrapper $visible={!!visible && nbPages > 1}>
      <PaginationAtom
        currentPage={currentRefinement}
        pages={nbPages}
        onSelect={goToPage}
      />
    </Wrapper>
  );
};
